import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=12e31631"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlockTxt: require('/var/www/html/fantini/frontend-2/components/block/txt/index.vue').default,BlocksWrapper: require('/var/www/html/fantini/frontend-2/components/blocks-wrapper/index.vue').default,BlockHeaderMagazineArticle: require('/var/www/html/fantini/frontend-2/components/block/header/magazine/article/index.vue').default,Composer: require('/var/www/html/fantini/frontend-2/components/composer/index.vue').default,BlockRecirculationMagazine: require('/var/www/html/fantini/frontend-2/components/block/recirculation/magazine/index.vue').default,BlockRecirculationNewsletter: require('/var/www/html/fantini/frontend-2/components/block/recirculation/newsletter/index.vue').default,Page: require('/var/www/html/fantini/frontend-2/components/page/index.vue').default})
